import axios from 'axios'
import { useEffect, useState } from 'react'

interface WeatherCallSuggestion {
  current: {
    condition: {
      icon: string
      text: string
    }
    humidity: number
    precip_mm: number
    temp_c: number
    wind_kph: number
  }
}

function useWeatherCall(city: string) {
  const [values, setValues] = useState<WeatherCallSuggestion | null | undefined>(undefined)

  useEffect(() => {
    const call = async () => {
      try {
        const { data: suggestion } = await axios.get<WeatherCallSuggestion>(
          `https://api.weatherapi.com/v1/current.json?q=${city}&lang=Es&key=${process.env.NEXT_PUBLIC_WEATHER_TOKEN!}`
        )
        setValues(suggestion)
      } catch (error) {
        console.error('Error fetching data, ', error)
        setValues(null)
      }
    }
    call()
  }, [city])

  return values
}

export default useWeatherCall
